import { render, staticRenderFns } from "./Reinsurance.vue?vue&type=template&id=eca22006&"
import script from "./Reinsurance.vue?vue&type=script&lang=js&"
export * from "./Reinsurance.vue?vue&type=script&lang=js&"
import style0 from "./Reinsurance.vue?vue&type=style&index=0&id=eca22006&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports